module.exports = __webpack_public_path__ + "static/media/twitter.838cbb86.svg";